// extracted by mini-css-extract-plugin
export default {"updateNotification":"styles_updateNotification__2MQr3","closeModalButtonContainer":"styles_closeModalButtonContainer__HEPB5","closeModalButton":"styles_closeModalButton__K-Bmu"};